import React from 'react';
import 'react-phone-input-2/lib/style.css';
import {
  Button,
  makeStyles,
  Select,
  Typography,
  Divider,
  MenuItem,
  ListItemText,
  Checkbox
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {useTranslation} from 'react-i18next';
const filterBaseStyles = makeStyles(() => ({
  root: {
    // width: '500px',
    minWidth: '300px',
    '&:focus': {
      outline: 'none'
    }
  },
  ClinicFilterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 16px'
  },
  clearAll: {
    textTransform: 'capitalize',
    fontSize: '1rem'
  },
  ClinicMenu: {
    overflow: 'auto',
    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  primary: {
    '& .MuiListItemText-primary': {
      fontSize: '1.2rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  secondary: {
    '& .MuiListItemText-secondary': {
      fontSize: '0.9rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    wordBreak: 'break-all'
  },
  outlined: {
    '& .MuiSelect-selectMenu': {
      width: '50% !important'
    },
    '& .MuiSelect-outlined': {
      flex: 0,
      paddingRight: '3.2rem',
      display: 'inline-block'
    },
    '& .MuiSelect-select': {
      flex: 0,
      minWidth: '80% !important'
    }
  },
  refresh: {
    paddingLeft: '0.1rem',
    display: 'none'
  }
}));

// FIXME: updated the types from 'any' to proper type
interface DropdownProps {
  data: any;
  selectedValues: any;
  handleItemChange: any;
  clearFilter: any;
  onClickCalled: any;
  primaryLabel: any;
  headerLabel: string;
  objKey: string;
  uniqueIdKey?: any;
  secondaryLabelKeys?: any;
  disabled?: boolean;
  className?: any;
}
const MultiSelectDropDownComponent = (
  props: DropdownProps
): React.ReactElement => {
  const baseClasses = filterBaseStyles();
  const {t} = useTranslation();
  // Get params from props
  const {
    selectedValues,
    data,
    handleItemChange,
    clearFilter,
    onClickCalled,
    primaryLabel,
    headerLabel,
    objKey,
    uniqueIdKey,
    secondaryLabelKeys,
    disabled = false,
    className
  } = props;
  const returnSecondaryLabelData = (obj: any) => {
    let str = '';
    if (
      secondaryLabelKeys &&
      Array.isArray(secondaryLabelKeys) &&
      secondaryLabelKeys.length > 0
    ) {
      secondaryLabelKeys.forEach(item => {
        str = `${str} ${obj[item]},`;
      });
      str = str.substring(0, str.length - 1);
    }
    return str;
  };
  return (
    <div
      className={className ? className : 'multi-select-dropdown-parent'}
      data-test-id="pcl-statements-failureReasons">
      <Select
        labelId="demo-multiple-name-label"
        id="demo-multiple-name"
        multiple
        // onBlur={onBlur}
        value={primaryLabel}
        margin={'dense'}
        fullWidth={true}
        name={'clinics'}
        variant="outlined"
        disabled={disabled}
        className={baseClasses.outlined}
        style={selectedValues?.length ? {} : {cursor: 'pointer'}}
        onChange={(e, clinic) => handleItemChange(e, clinic)}
        renderValue={selected => (selected as string[]).join(', ')}
        IconComponent={KeyboardArrowDownIcon}>
        <div className={baseClasses.root}>
          <div className={baseClasses.ClinicFilterHeader}>
            <Typography style={{fontSize: '1.3rem'}}>{headerLabel}</Typography>
            <Button
              className={baseClasses.clearAll}
              onClick={() => clearFilter()}
              data-test-id="pcl-appointments-notificationClearAll">
              {t('COMMON.CLEAR_ALL')}
            </Button>
          </div>
          <Divider />
          <div className={baseClasses.ClinicMenu}>
            {data &&
              data.map((item: any, index: number) => (
                <MenuItem
                  key={item[uniqueIdKey ? uniqueIdKey : objKey]}
                  value={item[objKey]}
                  onClick={(e: any): void => onClickCalled(e, item)}
                  data-test-id={`pcl-appointments-notificationFailureReason${index}`}>
                  <ListItemText
                    className={[
                      baseClasses.secondary,
                      baseClasses.primary
                    ].join(' ')}
                    primary={item[objKey]}
                    secondary={returnSecondaryLabelData(item)}
                  />
                  <Checkbox
                    checked={
                      selectedValues?.indexOf(
                        item[uniqueIdKey ? uniqueIdKey : objKey]
                      ) > -1
                    }
                  />
                </MenuItem>
              ))}
          </div>
        </div>
      </Select>
    </div>
  );
};
export default MultiSelectDropDownComponent;
